import React from 'react';
import {
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Grafico from '../../relatorios/components/grafico';
import Numeros from '../../relatorios/components/numeros';
import Recentes from '../../relatorios/components/recentes';
import Modificacoes from '../../relatorios/components/modificacoes';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Dashboard = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Dashboard"
    >
      <Container maxWidth={false}>
        <Grid
          container
          spacing={3}
        >
          <Grid item xs={8}>
            <Grafico />
          </Grid>
          <Grid item xs={4}>
            <Numeros colunas={2} />
          </Grid>
          <Grid item xs={8}>
            <Recentes />
          </Grid>
          <Grid item xs={4}>
            <Modificacoes />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default Dashboard;
